module.exports = __webpack_public_path__ + "img/aya-nakamura.6b8f9b61.jpg";